// gkc_hash_code : 01FJGW9AB4VKN1PM0CVCZY1PTE
export const pushActiveProduct = (dataType: string, image?: string) => {
  // max user id of agora 2^32-1
  const now = Date.now();
  const randomId = `${Math.floor(Math.random() * 4294967295)}${now}`;
  // eslint-disable-next-line
  const listItems = document.querySelectorAll(".product-active__item");
  const lastItem = listItems[listItems.length - 1];
  const displayTime =
    lastItem && lastItem?.getAttribute("data-display-time")
      ? parseInt(lastItem?.getAttribute("data-display-time") || "0", 10) + 5000
      : now;

  const productActive = document.createElement("div");
  const img = document.createElement("img");
  productActive.setAttribute("class", "product-active__item");
  productActive.setAttribute("data-type", dataType);
  productActive.setAttribute("id", randomId);
  productActive.setAttribute("data-display-time", `${displayTime}`);

  if (image) {
    img.setAttribute("src", image);
    productActive.appendChild(img);
  }
  productActive.addEventListener("click", () => {
    const productDisplay = document.getElementById(dataType);
    if (productDisplay) {
      productDisplay.scrollIntoView({ behavior: "smooth" });
    }
  });
  document.getElementById("product-active")?.appendChild(productActive);
  setTimeout(() => {
    document
      .getElementById(randomId)
      ?.setAttribute(
        "class",
        "product-active__item product-active__item--fadeOut"
      );
    setTimeout(() => {
      document.getElementById(randomId)?.remove();
    }, 300);
  }, displayTime - now + 5000);
};
